import React from 'react'
import { Icon } from '@iconify/react';

export default function ContactInfoWidget({withIcon, title}) {
  return (
    <>
      {title && <h2 className="cs-widget_title">{title}</h2>}
      <ul className="cs-menu_widget cs-style1 cs-mp0">
        <li>
          {withIcon?<span className='cs-accent_color'><Icon icon="mdi:office-building" /></span>:''}
          TUR DER HOFFNUNG
        </li>
        <li>
          {withIcon?<span className='cs-accent_color'><Icon icon="mdi:envelope" /></span>:''}
          <a href="https://turderhoffnung.com" target="_blank" rel="noreferrer">turderhoffnung.com</a>
        </li>
        <li>
          {withIcon?<span className='cs-accent_color'><Icon icon="mdi:map-marker" /></span>:''}
          50 Rawdon Street, <br/>Freetown, Sierra Leone
        </li>
        <li>
          {withIcon?<span className='cs-accent_color'><Icon icon="mdi:file-document-outline" /></span>:''}
          TIN: 1001205375
        </li>
        <li>
          {withIcon?<span className='cs-accent_color'><Icon icon="mdi:card-bulleted-outline" /></span>:''}
          Company No: SL280624TURDE22311
        </li>
      </ul>
    </>
  )
}
